
export default function AboutSection() {
  return (
    <section id="about" className="py-12 sm:py-16 md:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 px-2">
            会社概要
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            創業以来、お客様の信頼に応え続けてきた実績があります
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 md:gap-12 items-center">
          <div className="px-2">
            <img 
              src="https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/4f91a099c0dd444238bdabc835a433cb.png"
              alt="代表税理士"
              className="w-full h-64 sm:h-80 md:h-96 object-cover object-top rounded-lg shadow-lg"
            />
          </div>
          
          <div className="space-y-4 sm:space-y-6 px-2">
            <div>
              <h3 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-3 sm:mb-4">
                代表メッセージ
              </h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed mb-3 sm:mb-4">
                当事務所は、お客様一人ひとりのニーズに合わせた最適なサービスを提供することを使命としています。税務の専門知識を活かし、お客様の事業発展に貢献できるよう努めております。
              </p>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                複雑な税務問題から日常的な経理業務まで、幅広いサポートを通じて、お客様の成功をお手伝いいたします。
              </p>
            </div>
            
            <div className="grid grid-cols-2 gap-4 sm:gap-6">
              <div className="text-center p-3 sm:p-4 bg-white rounded-lg shadow">
                <div className="text-2xl sm:text-3xl font-bold text-blue-600 mb-1 sm:mb-2">25+</div>
                <div className="text-sm sm:text-base text-gray-600">年の実績</div>
              </div>
              <div className="text-center p-3 sm:p-4 bg-white rounded-lg shadow">
                <div className="text-2xl sm:text-3xl font-bold text-blue-600 mb-1 sm:mb-2">500+</div>
                <div className="text-sm sm:text-base text-gray-600">顧客数</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
